var _path, _circle, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21H3c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h18c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2zm0-16H3v14h18V5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.8,
    cy: 8.6,
    r: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2 17.1c-.3 0-.5-.1-.7-.3l-2.6-2.6-1.4 1.4c-.4.4-1 .4-1.4 0l-2.2-2.2-3.4 3.4c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l4.1-4.1c.4-.4 1-.4 1.4 0l2.2 2.2 1.4-1.4c.2-.2.4-.3.7-.3.3 0 .5.1.7.3l3.3 3.3c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3z"
  })));
}

export default SvgIconImage;